import { render, staticRenderFns } from "./FacebookLogsDetail.vue?vue&type=template&id=d2866e12&"
import script from "./FacebookLogsDetail.vue?vue&type=script&lang=js&"
export * from "./FacebookLogsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports